var map = {
  "./de.json": "599160",
  "./en.json": "852196",
  "./es-419.json": "921432",
  "./es.json": "711107",
  "./fr-CA.json": "502502",
  "./fr.json": "580063",
  "./hu.json": "43140",
  "./it.json": "778474",
  "./ja.json": "641522",
  "./nl.json": "229357",
  "./pt.json": "860991",
  "./sv.json": "260054"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function() { return Object.keys(map); };
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 775445;
